"use client";
import { useState } from "react";
import Image from "next/image";

// Simple reusable image with blur placeholder + pulse skeleton until load completes.
// Usage: <OptimizedImage src="..." alt="..." fill className="object-cover" />
// Accepts all next/image props.

const BLUR_DATA_URL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR4nGP89evXfwAJ5AMIMyJclwAAAABJRU5ErkJggg==";

export default function OptimizedImage(props) {
  const { className = "", style, priority = false, quality = 85, ...rest } = props;
  const [loaded, setLoaded] = useState(priority); // Priority images start as "loaded"

  // Auto-upgrade to .webp if developer provided a matching file (simple heuristic)
  // If a .webp path was directly passed we leave it. (Future: could probe via HEAD request, avoided for SSR perf.)
  return (
    <div className={`relative w-full h-full ${rest.fill ? '' : ''}`} style={style}>
      {!loaded && !priority && (
        <div className="absolute inset-0 rounded-md bg-[linear-gradient(120deg,#1f2f3d,#243848,#1f2f3d)] animate-pulse" aria-hidden="true" />
      )}
      <Image
        placeholder="blur"
        blurDataURL={BLUR_DATA_URL}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        quality={quality}
        onLoad={() => setLoaded(true)}
        {...rest}
        className={className + (loaded || priority ? ' opacity-100' : ' opacity-0 transition-opacity duration-300')}
      />
    </div>
  );
}
